"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AdapterDayjs", {
  enumerable: true,
  get: function () {
    return _AdapterDayjs.AdapterDayjs;
  }
});
var _AdapterDayjs = require("./AdapterDayjs");